var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 49",
    width: 49,
    height: 49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m850.17 540.54h-1081.11v-607h1081.11z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fc0}.b{fill:#593037}.c{fill:#7a424c}.d{fill:#25a2bc}.e{fill:#b3d81d}.f{opacity:.5;mix-blend-mode:multiply;fill:#b3b3b3}.g{opacity:.5;fill:#fff}.h{opacity:.7;mix-blend-mode:multiply;fill:#c1c0c6}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m48.5 24.3c0 13.2-10.7 23.9-23.8 23.9-13.2 0-23.9-10.7-23.9-23.9 0-13.2 10.7-23.8 23.9-23.8 13.1 0 23.8 10.6 23.8 23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m24.1 38h2.8v-4.2h-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.5 38.1h12v-0.9h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m17.9 38.9h15.1v-0.8h-15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m16.8 30.9c4.8 4.8 12.6 4.8 17.3 0l-0.7-0.8c-4.4 4.4-11.5 4.4-15.8 0.1-4.4-4.4-4.4-11.5 0-15.9l-0.8-0.7c-4.7 4.8-4.7 12.5 0 17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m33.9 31.2c0.2 0.2 0.6 0.2 0.8 0 0.2-0.2 0.2-0.6 0-0.8l-17.3-17.3c-0.2-0.3-0.6-0.3-0.8 0-0.3 0.2-0.3 0.6 0 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m35.6 19.1c1.7 5.5-1.4 11.3-6.9 13-5.5 1.7-11.3-1.4-13-6.9-1.7-5.5 1.3-11.3 6.8-13 5.6-1.7 11.4 1.3 13.1 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m34.1 16c-0.5 0.3-1.3-0.2-1.8-0.1-0.8 0.1-0.7 0.7-1.1 1.1-0.4 0.3-1 0.1-1.5 0.2-1.2 0.1-0.7 0.7 0.3 0.7 0.4 0 1.3-0.4 1.7-0.2 0.8 0.3 0.1 1.4-0.3 1.8-1 0.8-2.2 0.5-3.3 0-0.7 0.2-0.2 0.8 0.1 1 0.5 0.5 1.2 0.5 1.8 0.6 1.4 0.3 1.3 1.3 1.5 2.5 0.2 1.1 0.1 2.3 0.5 3.2 0.3 0.7 1 1.6 1.3 2.5q-1.1 1.1-2.4 1.9c-0.8-0.4-1.7-1.2-2.2-1.5-0.7-0.3-1.6-0.6-2-1.3-0.4-0.5-0.3-1.1-0.8-1.7-1.2-1.1-1.9 1.2-3.4 1-0.8-0.1-0.9-0.7-1.4-1.1-0.8-0.4-1.1-0.4-1.5-1.3-1.3-2.4 0.6-4.5 2.8-5.4 0.3 0.1 1.3-0.6 1.8-0.8 0.5-0.3 1.1-0.3 1.8-0.5-0.2-0.6-0.8-0.2-1.2-0.5-0.3-0.2-0.4-0.4-0.6-0.8 0.4-0.5 1.2-0.4 0.9-1.2-0.1-0.6-1-0.8-1.4-0.4-0.6 0.5 0.1 1.2-0.8 1.4-0.4 0.1-1.2-0.4-1.4 0.2-0.1 0.6 3.4 1 1.3 1.5-0.4 0-1.2 0.2-1.5 0.2-0.7 0-1.2-0.9-1.9-0.4 0.1 0.4 0.8 0.6 1 1.1-0.7 0.7-1.1-0.4-1.7-0.3-0.8 0.1-0.3 1.2-0.3 1.7 0.1 0.5 0.1 1-0.6 1.2-0.8 0.3-0.7-0.1-0.8-0.7-0.2-0.9-0.2-1 0.3-1.8 0.4-0.6 0.1-1.1 0.5-1.7 0.4-0.5 1-0.7 1.3-1.1 0.5-0.6 0.5-1.6-0.4-1.1-0.3 0.2-0.7 1.1-1.1 1.1-0.7-0.1-0.1-0.9 0.1-1 0.7-0.6 0.8-0.3 0.6-1.1q0-0.1-0.1-0.1c1.2-1.2 2.7-2.1 4.3-2.6 4.4-1.4 9 0.3 11.6 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m34.6 27.3c-0.6 0.1-1.2-0.9-1.5-1.4-0.4-0.6-0.3-1.1-0.3-1.7 0.3-0.2 0.9 0 1.3 0.6 0.5 0.8 0.4 1.7 0.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m28.7 32.1c-5.5 1.7-11.3-1.4-13-6.9-1.7-5.5 1.3-11.3 6.8-13q0.7-0.2 1.4-0.4c-4.4 1.7-6.8 6.6-5.4 11.1 1.5 4.8 6.6 7.5 11.3 6 3.4-1 5.7-3.9 6.3-7.1 0.1 4.6-2.8 8.9-7.4 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m31.2 16.2c0 0.8-0.7 1.5-1.6 1.5-0.8 0-1.5-0.7-1.5-1.5 0-0.9 0.7-1.6 1.5-1.6 0.9 0 1.6 0.7 1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m33 38.9l-9.2 9.3c-11.4-0.4-20.7-8.8-22.6-19.7l15.4-15.4q-0.2 0.1-0.2 0.4 0 0.2 0.2 0.4c-4.5 4.8-4.4 12.3 0.2 17 2.1 2 4.7 3.2 7.3 3.5v2.8h-4.6v0.9h-1.6v0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m33.1 30.4c-4.4 4.1-11.3 4-15.5-0.2-4.3-4.3-4.4-11.2-0.3-15.6l0.5 0.6q-0.4 0.5-0.8 1.1-0.8 1.2-1.3 2.6-0.1 0.4-0.2 0.8c-0.4 1.8-0.4 3.7 0.2 5.5 1.7 5.5 7.5 8.6 13 6.9q0.2-0.1 0.4-0.1 0.4-0.2 0.8-0.4 0.5-0.2 1-0.4 0.1-0.1 0.1-0.1 0.3-0.2 0.6-0.4 0.1-0.1 0.2-0.2 0.2-0.1 0.3-0.2 0.2-0.2 0.5-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m34.7 31.2l-6 6h-1.8v-2.8c2.5-0.3 5-1.4 6.9-3.2h0.1c0.2 0.2 0.6 0.2 0.8 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.3dc0c8bcccb6aec0a922192da3077b39.svg";
export { ForwardRef as ReactComponent };